import { useState } from "react";
import "./MintologySite.css";

export default function App() {
  const [password, setPassword] = useState("");
  const [accessGranted, setAccessGranted] = useState(false);

  const correctPassword = "RONIO";
  const hiddenImageLink = "https://imgur.com/a/4os7Iss";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.toUpperCase() === correctPassword) {
      setAccessGranted(true);
    } else {
      alert("Nieprawidłowe hasło. Spróbuj ponownie.");
    }
  };

  return (
    <div className="container">
      <h1>Czas ucieka. Orion tonie.</h1>
      <p>Rozszyfruj prawdę.</p>
      <form onSubmit={handleSubmit} className="form-container">
        <input
          type="text"
          placeholder="Wpisz hasło"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="input-field"
        />
        <button type="submit" className="submit-button">
          Prześlij
        </button>
      </form>
      {accessGranted && (
        <div className="access-message">
          <p>Dostęp przyznany. Znajdziesz wskazówkę tutaj:</p>
          <a href={hiddenImageLink} target="_blank" rel="noopener noreferrer">
            Kliknij, aby zobaczyć obraz
          </a>
        </div>
      )}
    </div>
  );
}
